<template>
  <div class="logo-button" :class="{ 'bel-airexpress': logoKey === 0, 'bax-technics': logoKey === 1 }">
    <el-popover
      placement="top-start"
      width="200"
      trigger="manual"
      v-model="isVisible"
      class="logo-button__popover"
    >
      <div slot="reference" class="logo-button__wrap">
        <button class="btn btn-size-s logo-button__btn-main" :disabled="disabled" :class="btnClass" @click.prevent="handleClick">
          <slot></slot>
        </button>
        <button class="btn btn-size-s logo-button__btn-arrow" :disabled="disabled" :class="btnClass" @click.prevent="handleClickArrow">
          <i class="el-icon-arrow-down el-icon--right"></i>
        </button>
      </div>
      <ul class="logo-button__ul">
        <li class="logo-button__li bel-airexpress" :class="{'is-active': logoKey === 0}" @click="handleCommand(0)">{{L10n('bel-airexpress-logo')}}</li>
        <li class="logo-button__li bax-technics" :class="{'is-active': logoKey === 1}" @click="handleCommand(1)">{{L10n('bax-technics-logo')}}</li>
        <li v-if="getPdfContent" class="logo-button__li" @click="onPreview">{{L10n('preview-pdf')}}</li>
      </ul>
    </el-popover>
    <dialog-info :title="L10n('preview-pdf-title')" ref="dialog-info" :is-loading="isLoading">
      <html-iframe :html="htmlContent" />
    </dialog-info>
  </div>
</template>

<script>
import DialogInfo from '@/components/Dialogs/DialogScroll'
import HtmlIframe from '@/components/html-iframe'

export default {
  name: 'LogoButton',
  components: { HtmlIframe, DialogInfo },
  props: {
    btnClass: { type: String },
    text: { type: String },
    disabled: { type: Boolean, default: false },
    getPdfContent: { type: Function }
  },
  data () {
    return {
      isVisible: false,
      logoKey: 0,
      htmlContent: '',
      isLoading: false
    }
  },
  methods: {
    handleClickArrow () {
      this.isVisible = !this.isVisible
    },
    handleClick () {
      this.$emit('click', this.logoKey)
      this.isVisible = false
    },
    handleCommand (logoKey) {
      this.logoKey = logoKey
      this.isVisible = false
    },
    async onPreview () {
      try {
        this.isVisible = false
        this.isLoading = true
        this.$refs['dialog-info'].show()
        const { content } = await this.getPdfContent()
        this.htmlContent = content
      } catch (e) {
        this.$refs['dialog-info'].close()
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
<style lang="stylus">
  .frame_pdf {
    width 100%
    height 100%
  }
  .logo-button{
    display flex
    flex-wrap nowrap
    &__popover{
      display block;
      width: 100%;
    }
    &__wrap{
      display flex
      flex-wrap nowrap
    }
    &__btn-main{
      &.btn {
        width 100%
        border-radius 5px 0 0 5px
      }
    }
    &__btn-arrow{
      &.btn {
        min-width unset!important
        border-radius 0 5px 5px 0
        margin-left 1px
      }
    }
    &__ul{
      margin 0
      list-style-type none
    }
    &__li{
      padding .5rem
      &:hover{
        cursor pointer
      }
      &.bel-airexpress{
        &:hover,
        &.is-active{
          color #06aaea
        }
      }
      &.bax-technics{
        &:hover,
        &.is-active{
          color #ef8176
        }
      }
    }
    button {
      line-height: 1.2;
      padding: 0.8rem 1.3rem;
      font-size: 1.2rem;
      border-radius: 5px;
      text-transform: uppercase;
    }
    &.bax-technics{
      button{
        background-color: #ef8176;
      }
    }
  }
</style>
